import buildTypeIcon from '@jetbrains/icons/buildType-14px.svg'
import confirm from '@jetbrains/ring-ui/components/confirm-service/confirm-service'
import Icon from '@jetbrains/ring-ui/components/icon'
import Tooltip from '@jetbrains/ring-ui/components/tooltip/tooltip'
import {memo, useCallback} from 'react'
import {useSearchParams} from 'react-router-dom'

import {useAppDispatch} from '../../../../../../hooks/react-redux'
import {defaultPipelineJobAgent} from '../../../CreatePipelinePage/hooks/useCreatePipeline.consts'
import {usePipelineId} from '../../../hooks/pipeline'
import {useGenerateFreeJobId} from '../../EditPipelinePage.hooks'
import {pipelineDraft} from '../../slices/EditPipelinePage.slices'

import styles from './AddJob.css'

const jobCountSoftLimit = window.internalProps['teamcity.pipelines.jobCountSoftLimit']
const jobCountHardLimit = window.internalProps['teamcity.pipelines.jobCountHardLimit']

type Props = {
  jobCount: number
}

function AddJob({jobCount}: Props) {
  const dispatch = useAppDispatch()
  const [, setSearchParams] = useSearchParams()
  const generateFreeJobId = useGenerateFreeJobId()
  const id = usePipelineId()

  const onClick = useCallback(async () => {
    let proceed = true

    if (jobCountSoftLimit != null && jobCountSoftLimit > 0 && jobCount >= jobCountSoftLimit) {
      try {
        await confirm({
          text: 'Job count warning',
          description: `The pipeline editor is optimized to work with no more than ${jobCountSoftLimit} jobs.`,
          confirmLabel: 'Add job anyway',
          rejectLabel: 'Cancel',
        })
      } catch (e) {
        proceed = false
      }
    }

    if (proceed) {
      const jobId = generateFreeJobId()
      dispatch(
        pipelineDraft.actions.addJob({
          id,
          jobId,
          job: {
            'runs-on': defaultPipelineJobAgent,
          },
        }),
      )
      setSearchParams({job: jobId})
    }
  }, [jobCount, generateFreeJobId, dispatch, id, setSearchParams])

  const limited = jobCount >= jobCountHardLimit

  const button = (
    <button
      type="button"
      onClick={onClick}
      className={styles.button}
      disabled={limited || undefined}
    >
      <Icon glyph={buildTypeIcon} className={styles.icon} />
      <span className={styles.name}>{'Add…'}</span>
    </button>
  )

  return limited ? (
    <Tooltip delay={100} title={`Max number of jobs is ${jobCountHardLimit}`}>
      {button}
    </Tooltip>
  ) : (
    button
  )
}

export default memo<Props>(AddJob)
